import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Text } from 'hb-react/shared/components/formik/components/inputs';

import style from './index.module.scss';

const CustomFund = ({ gift, name, biggerDisplay, giftCustomFundError }) => {
  if (!gift.is_fallback) {
    return null;
  }

  return (
    <div
      className={classNames('inline-block text--right', {
        field_with_errors: giftCustomFundError,
      })}
    >
      <div
        className={classNames('inline-block', {
          [style['component--bigger']]: biggerDisplay,
        })}
      >
        <div data-testid="custom-fund">
          <div
            style={{
              maxHeight: '10px',
              marginBottom: '35px',
              paddingBottom: '12px',
              marginLeft: '15px',
            }}
          >
            <Text
              name={name}
              placeholder={__('Write in your designation *')}
              validate={{
                required: true,
              }}
              wrapperProps={{
                width: '250px',
              }}
            />
          </div>
        </div>
      </div>
      {giftCustomFundError && (
        <span className="error">{giftCustomFundError}</span>
      )}
    </div>
  );
};

CustomFund.propTypes = {
  name: PropTypes.string,
  gift: PropTypes.object.isRequired,
  biggerDisplay: PropTypes.bool,
  giftCustomFundError: PropTypes.string,
};

CustomFund.defaultProps = {
  biggerDisplay: false,
};

export default CustomFund;
